import { useDataExportCombinedMonthToDate } from '@gonfalon/billing/hooks';
import { msg } from '@gonfalon/messages/msg';

import { type Account, type Subscription } from '../model';

import { AccountContextProvider } from './AccountContextProvider';
import { BillingLimitRow } from './BillingLimitRow';

const USAGE_LOAD_ERROR = { status: 0, message: 'Failed to load Data Export transfers' } as const;

type DataExportTransfersLimitRowProps = {
  account: Account;
  subscription: Subscription;
  limit: number;
};

function DataExportTransfersUsage({ limit }: { limit: number }) {
  const { total, isLoading, isError } = useDataExportCombinedMonthToDate();

  return (
    <BillingLimitRow
      title={msg('billing.dataExportCombined.transfersLabel')}
      limit={limit}
      usage={isLoading || isError ? undefined : total}
      isLoading={isLoading && !isError}
      error={isError ? USAGE_LOAD_ERROR : undefined}
    />
  );
}

export function DataExportTransfersLimitRow({ account, subscription, limit }: DataExportTransfersLimitRowProps) {
  return (
    <AccountContextProvider account={account} subscription={subscription}>
      <DataExportTransfersUsage limit={limit} />
    </AccountContextProvider>
  );
}
